import {
  FilterPanel,
  OrgFilter,
  SessionIdFilter,
  UserFilter,
  type FilterOption,
} from "./FilterPanel";

// ``FilterOption`` is intentionally not re-exported from this module — sibling
// callers should import it directly from ``./FilterPanel`` so the type's home
// is unambiguous (mirrors what ``FeedbackFilters.tsx`` already does).

export interface ChatFiltersValues {
  org: FilterOption | null;
  user: FilterOption | null;
  sessionId: string;
}

interface ChatFiltersProps {
  values: ChatFiltersValues;
  onChange: (values: ChatFiltersValues) => void;
  onSearch: () => void;
  onClear: () => void;
  isLoading: boolean;
  orgOptions: FilterOption[];
  userOptions: FilterOption[];
  orgOptionsLoading: boolean;
  userOptionsLoading: boolean;
}

export function ChatFilters({
  values,
  onChange,
  onSearch,
  onClear,
  isLoading,
  orgOptions,
  userOptions,
  orgOptionsLoading,
  userOptionsLoading,
}: ChatFiltersProps) {
  return (
    <FilterPanel onSearch={onSearch} onClear={onClear} isLoading={isLoading}>
      <OrgFilter
        value={values.org}
        onChange={(org) => onChange({ ...values, org })}
        options={orgOptions}
        loading={orgOptionsLoading}
      />
      <UserFilter
        value={values.user}
        onChange={(user) => onChange({ ...values, user })}
        options={userOptions}
        loading={userOptionsLoading}
      />
      <SessionIdFilter
        value={values.sessionId}
        onChange={(sessionId) => onChange({ ...values, sessionId })}
      />
    </FilterPanel>
  );
}
